import { get } from 'lodash';
import moment from 'moment';
import {
  FETCH_ALL_LEADS,
  FETCH_ALL_LEADS_SUCCESS,
  FETCH_ALL_LEADS_ERROR,
  FETCH_LEAD_BY_ID,
  FETCH_LEAD_BY_ID_SUCCESS,
  FETCH_LEAD_BY_ID_ERROR,
  FETCH_ALL_POC_USER,
  FETCH_ALL_POC_USER_SUCCESS,
  FETCH_ALL_POC_USER_ERROR,
  SAVE_LEAD_FILTERS,
} from './actionTypes';
import {
  FETCH_ALL_CENTRE_WAITLIST,
  FETCH_DETAIL_ENQUIRY,
  FIND_ALL_POC_USER,
  GET_CHILD_CURRENT_CENTRE,
} from '../models/enquiriesManagementModels';
import { GET_EXISTING_CHILD } from '../models/admissionModel';
import { DATE_PICKER_FORMAT } from '../../utils/constants';
import { SkApolloRequest } from '../../utils/apolloUtils';

export const saveLeadFilters = filter => async dispatch => {
  dispatch({ type: SAVE_LEAD_FILTERS, value: { filter } });
};

export const fetchCentreWaitlistAction = reqData => async dispatch => {
  dispatch({ type: FETCH_ALL_LEADS });
  try {
    const data = await SkApolloRequest({
      params: {
        query: FETCH_ALL_CENTRE_WAITLIST,
        variables: { ...reqData },
      },
      type: 'query',
    });
    const success = get(data, 'success', false);
    const { findAllLeads } = get(data, 'data', {});
    if (success) {
      dispatch({
        type: FETCH_ALL_LEADS_SUCCESS,
        value: { findAllLeads },
      });
    } else {
      dispatch({
        type: FETCH_ALL_LEADS_ERROR,
        value: get(data, 'error'),
      });
    }
    return data;
  } catch (ex) {
    dispatch({
      type: FETCH_ALL_LEADS_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

export const fetchEnquiryDetailAction = reqData => async dispatch => {
  dispatch({ type: FETCH_LEAD_BY_ID });
  try {
    const data = await SkApolloRequest({
      params: {
        query: FETCH_DETAIL_ENQUIRY,
        variables: { ...reqData },
      },
      type: 'query',
    });
    const success = get(data, 'success', false);
    const { leadByID } = get(data, 'data', {});
    if (success) {
      dispatch({
        type: FETCH_LEAD_BY_ID_SUCCESS,
        value: { leadByID },
      });
    } else {
      dispatch({
        type: FETCH_LEAD_BY_ID_ERROR,
        value: get(data, 'error'),
      });
    }
    return data;
  } catch (ex) {
    dispatch({
      type: FETCH_LEAD_BY_ID_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

export const fetchAllPOCUser = reqData => async dispatch => {
  dispatch({ type: FETCH_ALL_POC_USER });
  try {
    const res = await SkApolloRequest({
      params: {
        query: FIND_ALL_POC_USER,
        variables: { ...reqData },
      },
      type: 'query',
    });
    if (res.success) {
      dispatch({
        type: FETCH_ALL_POC_USER_SUCCESS,
        value: {
          data: get(res, 'data.findAllPOCUser.data'),
        },
      });
    } else {
      dispatch({
        type: FETCH_ALL_POC_USER_ERROR,
        value: {
          error: get(res, 'error.0.message'),
        },
      });
    }
  } catch (ex) {
    dispatch({
      type: FETCH_ALL_POC_USER_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

/**
 * To get the child source centre based on birth certificate + date of birth because lead does not have the childID
 */
export const fetchChildCurrentCentre = async (
  birthCertificate,
  dateOfBirth
) => {
  if (!birthCertificate || !dateOfBirth) return null;
  try {
    const existingChildRes = await SkApolloRequest({
      params: {
        query: GET_EXISTING_CHILD,
        variables: {
          birthCertificate,
          dateOfBirth: moment(dateOfBirth).format(DATE_PICKER_FORMAT),
        },
      },
      type: 'query',
    });
    const childID = get(existingChildRes, 'data.getExistingChildV2.child.ID');
    if (!get(existingChildRes, 'success') || !childID) return null;

    const childRes = await SkApolloRequest({
      params: {
        query: GET_CHILD_CURRENT_CENTRE,
        variables: { IDChild: childID },
      },
      type: 'query',
    });
    if (!get(childRes, 'success')) return null;
    return get(childRes, 'data.childByID.closestLevel.centre', null);
  } catch (ex) {
    return null;
  }
};
